import { ok, err, Result } from 'neverthrow';

import { Period, type PeriodOps } from './period.js';
import { YearMonth } from './year_month.js';

export type YearMonthSpanDto = {
  first: YearMonth;
  last: YearMonth;
};

export const yearMonthOps: PeriodOps<YearMonth> = {
  compare: YearMonth.compare,
  next: YearMonth.next,
  display: YearMonth.display,
};

export class YearMonthSpan extends Period<YearMonth> {
  private constructor(firstInPeriod: YearMonth, lastInPeriod: YearMonth) {
    super(firstInPeriod, lastInPeriod, yearMonthOps);
  }

  toJSON(): { first: YearMonth; last: YearMonth } {
    return { first: this.firstInPeriod, last: this.lastInPeriod };
  }

  public static fromYearMonthDto(yearMonthSpan: YearMonthSpanDto): Result<YearMonthSpan, Error> {
    try {
      const first = yearMonthSpan.first;
      const last = yearMonthSpan.last;
      if (first > last) {
        return err({
          name: 'Invalid YearMonthSpan',
          message: `Invalid Time.YearMonthSpanDto: first date (${first}) must be earlier than last date (${last}).`,
        });
      }
      return ok(new YearMonthSpan(first, last));
    } catch (e) {
      return err({
        name: 'Unknown',
        message: e as string,
      });
    }
  }

  /**
   * Use when YearMonthSpan is used as a key in a record.
   */
  public get key(): YearMonth {
    return this.lastInPeriod;
  }
}
